<template>
  <div :class="['apInput', { 'apInput--error': hasErrorText }]">
    <div class="apInput__inner">
      <label
        v-if="label" 
        class="apInput__label"
      >
        {{ label }}
      </label>
      <div :class="['apInput__field', {'apInput__field--border': border}]">
        <input
          class="apInput__input"
          :type="composeMask"
          :value="modelValue"
          :placeholder="placeholder"
          :disabled="disabled"
          :maxlength="length"
          :max="max"
          @input="input"
        >
        <div v-if="currency">₸</div>
      </div>
    </div>
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-show="hintOrError"
        class="apInput__hint"
      >
        {{ hintOrError }}
      </div>
    </transition>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'ApInput',

  props: {
    type: {
      type: String,
      default: 'text',
    },
    modelValue: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    length: {
      type: String,
      default: '255'
    },
    max: {
      type: String,
      default: '255'
    },
    border: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const store = useStore();
    const hasErrorText = computed(() => props.errorText.length > 0);
    const isDefault = computed(() => store.getters['isDefault']);
    
    const hintOrError = computed(() => {
      if (hasErrorText.value){
        return props.errorText;
      }
      return props.hint;
    });

    const composeMask = computed(() => {
      switch (props.type){
      case 'cvv':
        return 'password';
      default: 
        return props.type;
      }
    });

    const input = (e: Event) : void => {
      const text = e.target as HTMLInputElement;
      emit('update:modelValue', text.value);
    };
    return {
      hasErrorText,
      hintOrError,
      input,
      composeMask,
      isDefault
    };
  },
});
</script>

<style lang="scss" scoped>
.apInput{
  display: flex;
  flex-direction: column;
  &__input{
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    border: none;
    &:focus{
      outline: none;
    }
    &:disabled{
      background-color: #ffffff;
    }

  }
  &__hint {
      font-size: 12px;
      margin-top: 6px;
      color: rgba(0,0,0, .6);
  }
  &__field{
    display: flex;
    overflow: hidden;
    padding: 10px;
    align-items: center;
    width: 100%;
    position: relative;

    &--border{
      border: none;
    }
     &__input::placeholder {
      line-height: 24px;
    }
  }
  &__label{
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.72);
    margin-bottom: 6px;
    display: block;
  }
  &__icon{
    display: block;
    height: 24px;
    width: 24px;
  }
}

.default{
  .apInput{
    &__field{
      border: 1px solid $secondary-gray;
      border-radius: 6px;
      line-height: 22px;
      &--border{
        border: none;
      }
    }
  }
  .apInput--error{
    .apInput{
      &__field{
        border: 1px solid red;
      }
      &__label{
        color: red;
      }
      &__hint{
        color: red;
      }
      &__code{
        color: red;
      }
      &__input{
        color: red;
      }
    }
  }
}
.tele2{
  .apInput{
    font-family: "Open Sans";      
    &__field{
      border-bottom: 1px solid $tele2-primary-gray;
      line-height: 24px;
      padding: 8px 0;
      &--border{
        border: none;
        padding: 8px;
      }
    }
    &__label{
      font-weight: 600;
      color: $tele2-primary-gray;
      font-size: 13px;
      line-height: 16px;
      margin-bottom: 7px;
    }
  }
  .apInput--error{
    .apInput{
      &__field{
        border-bottom-color:red;
      }
      &__label{
        color: red;
      }
      &__hint{
        color: red;
      }
      &__code{
        color: red;
      }
      &__input{
        color: red;
      }
    }
  }
}
.altel{
  .apInput{
    &__field{
      border: 1px solid $secondary-gray;
      background: #F8F8F8;
      border-radius: 4px;
      line-height: 24px;
      &--border{
        border: none;
        background:none;
        .apInput__input{
          background:none;
        }
      }
    }
    &__input{
      background: #F8F8F8;
    }
    &__label{
      font-weight: 500;
      color: $primary-gray;
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 8px;
    }
  }
  .apInput--error{
  .apInput{
    &__field{
      border-color: red;
    }
    &__label{
      color: red;
    }
    &__hint{
      color: red;
    }
    &__code{
      color: red;
    }
    &__input{
      color: red;
    }
  }
}
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
